import { cn } from "@/components/ui/utils";

export function Centered(props: React.ComponentProps<"div">) {
  return (
    <div
      {...props}
      className={cn(
        "flex items-center justify-center h-full w-full",
        props.className,
      )}
    />
  );
}

// TODO: export from react-aria-components when available in next release
export { ClearPressResponder, Pressable } from "@react-aria/interactions";
